/**
 * Utility for getting URL path for active monitor patients
 *
 * @export
 * @param {*} { asmpid, tileData, key } Takes Patient asmpid, tileData object, and key
 * @return {string} Returns URL path /patient/{asmpid}/monitor/live if patient is active
 */
export default function patientNavigationPath(asmpid, status, subRoute) {
  // AS1-4269 Drop user into live mode from tiles if active
  const isLive = status === "active" && subRoute === "monitor" ? "live" : "";
  const path = `/patient/${asmpid}/${subRoute}/${isLive}`;
  return path;
}
